import { type JSX } from "react";
import { Box } from "@mui/material";
import { Button } from "@platform/design-system";

interface RatesDrawerFooterProps {
  /** Whether the structure "Save" button is shown (hidden on the current plan). */
  showSave: boolean;
  saveDisabled: boolean;
  onSave: () => void;
  onClose: () => void;
}

/**
 * Footer for the rates drawer. The current-plan (rate-sets) drawer has no
 * structure save — renewal/revised rates save from within the Rate Sets
 * section — so only a Close button is shown there.
 */
export const RatesDrawerFooter = ({
  showSave,
  saveDisabled,
  onSave,
  onClose,
}: RatesDrawerFooterProps): JSX.Element => (
  <Box
    sx={{ display: "flex", gap: 2, justifyContent: "flex-end", width: "100%" }}
  >
    <Button variant="tertiary" onClick={onClose}>
      {showSave ? "Cancel" : "Close"}
    </Button>
    {showSave && (
      <Button variant="primary" onClick={onSave} disabled={saveDisabled}>
        Save
      </Button>
    )}
  </Box>
);
